import {useEffect} from 'react';
import {updateCollapsableSidebarState} from '@Components/poster-editor/poster-editor-reducer';
import useWindowSize from '@Hooks/useWindowSize';
import {useAppDispatch} from '@/hooks';
import {EDITOR_COLLAPSABLE_SIDEBAR_THRESHOLD} from '@Components/poster-editor/poster-editor.types';

export const useHandleEditorSidebarCollapsibleState = (): void => {
  const {windowWidth} = useWindowSize();
  const dispatch = useAppDispatch();

  const isSidebarCollapsable = (): boolean => {
    return windowWidth < EDITOR_COLLAPSABLE_SIDEBAR_THRESHOLD;
  };

  useEffect(() => {
    dispatch(updateCollapsableSidebarState(isSidebarCollapsable()));
  }, [windowWidth]);
};
